import { type AnyApiGridQueryStateValue } from "@package/ui-redux";
import { type PropsWithChildren } from "react";
import { ItemGridFilterProvider } from "../ItemGridFilter/context-item-grid-filter-provider";

type ItemGridFilterPanelProps = PropsWithChildren<{
  filter?: AnyApiGridQueryStateValue["variables"]["filter"];
  onFilterChanged?: (
    filter: AnyApiGridQueryStateValue["variables"]["filter"],
  ) => void;
}>;

export function ItemGridFilterPanel({
  filter,
  onFilterChanged,
  children,
}: ItemGridFilterPanelProps) {
  return (
    <ItemGridFilterProvider filter={filter} onFilterChanged={onFilterChanged}>
      <div className="flex flex-col h-full w-full overflow-auto">
        {children}
      </div>
    </ItemGridFilterProvider>
  );
}
